import { FC, ReactNode } from 'react';

import { styled } from '../../theme';
import SvgIcon from '../SvgIcon';

const Container = styled.span({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
});

type Props = {
    children: ReactNode;
    isSelected: boolean;
    iconSrc?: string;
};

const AIModeLabel: FC<Props> = ({ children, isSelected, iconSrc = '/icons/ic-ai.svg' }) => (
    <Container>
        <SvgIcon
            src={iconSrc}
            alt=""
            width={13}
            height={13}
            color={(theme) => (isSelected ? theme.color.white : theme.color.tertiaryIcon)}
        />
        {children}
    </Container>
);

export default AIModeLabel;
